import { render, staticRenderFns } from "./LockersOrders.vue?vue&type=template&id=30476109&"
import script from "./LockersOrders.vue?vue&type=script&lang=ts&"
export * from "./LockersOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports